export default "__VITE_ASSET__DYwRamny__"